class relationPcas {
  constructor(pcaId, pcaName, pcaDescription, roles) {
    this.pcaId = pcaId;
    this.pcaName = pcaName;
    this.pcaDescription = pcaDescription;
    this.roles = roles;
  }

  static fromJson({ pcaId, pcaNombre, pcaDescripcion, roles }) {
    return new relationPcas(pcaId, pcaNombre, pcaDescripcion, roles);
  }
}

export default relationPcas;
